// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#homepage {
  background-color: #fff;
}

h2 {
  font-family: var(--font2);
}

h2.why-us {
  font-size: 36px;
  text-align: center;
  color: var(--textColour);
  letter-spacing: -1px;
  font-weight: 700;
}

h3 {
  color: #034fa0 !important;
  font-size: 1.3rem;
  font-weight: 700;
}

h3.no-test {
  color: var(--primaryButtonColour) !important;
}

.header-line-1, .header-line-3 {
  color: #717173 !important;
  font-size: 38px !important;
  font-weight: 500 !important;
}

.header-line-2 {
  font-size: 50px !important;
  color: #191c1f;
}

.btn-sign-up, .btn-login {
  line-height: 50px;
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -1px;
}

.center-box {
  min-height: max(480px, var(--homepageVideoHeight));
}

.box-shadow {
  box-shadow: 0 12px 32px 5px rgba(1, 13, 130, 0.12);
}

.block-1 {
  background-color: #fff;
}

.block-2 {
  background-color: var(--colour3);
}

.block-3 {
  background-color: var(--colour3);
}

.inner-block-1 {
  height: 100%;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center right;
}

.header-block {
  display: block;
  color: var(--colour5);
}
.header-block .header-line-1 {
  font-size: 48px;
  line-height: 45px;
  letter-spacing: -1px;
  font-weight: 700;
  font-family: var(--font2);
}
.header-block .header-line-2 {
  font-size: 62px;
  line-height: 54px;
  font-weight: 700;
  letter-spacing: -1px;
  font-family: var(--font2);
}
.header-block .header-line-3 {
  font-size: 48px;
  line-height: 45px;
  font-weight: 600;
  letter-spacing: -1px;
  color: #fff;
  font-family: var(--font2);
}

.btn-sign-up {
  font-weight: 600;
  border-radius: 25px !important;
  height: 50px;
  padding: 0 25px;
  border: none !important;
  color: #fff !important;
}
.btn-sign-up:hover {
  background-color: #333 !important;
}

.btn-login {
  font-weight: 600;
  height: 50px;
  border-radius: 25px !important;
  padding: 0 25px;
  border: 1.5px solid var(--tertiaryButtonBackgroundColour) !important;
  color: var(--tertiaryButtonBackgroundColour) !important;
  background-color: #fff !important;
}
.btn-login:hover {
  background-color: var(--tertiaryButtonHoverBackgroundColour) !important;
}

.more-info-block {
  display: block;
  height: 100%;
  background-color: #fff;
  padding: 20px 40px 0 40px;
  border-radius: 8px;
  box-shadow: 0px 12px 32px 5px rgba(1, 13, 130, 0.12);
  margin-bottom: 1rem;
  text-align: center;
}
.more-info-block .info-text {
  color: #333;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
}
.more-info-block div {
  padding-bottom: 6px;
}
.more-info-block h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin-top: 20px;
}

.upcoming-sales {
  color: var(--linkColour);
  display: inline-block;
  font-weight: 600;
}

.sales-calendar-button {
  display: inline-block;
  color: #fff;
  padding: 5px 7px;
  border-radius: 5px;
  background-color: rgba(42, 157, 143, 0.8);
  color: #fff;
}

.sale-table-wrapper {
  background-color: var(--homepageCalendarBackgroundColour);
  color: #fff;
  border-radius: 8px;
  padding: 10px 20px 10px 20px;
  box-shadow: 0px 12px 32px 5px rgba(1, 13, 130, 0.12);
}
.sale-table-wrapper .sale-table {
  width: 100%;
  color: #fff;
  font-weight: 500;
  border-collapse: collapse;
  border-style: hidden;
}
.sale-table-wrapper .sale-table td {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: 600;
}

.sub-header h3 {
  font-weight: 700;
  color: var(--textColour) !important;
}

#home-box1-widget {
  min-width: 300px;
}

@media only screen and (min-width: 1200px) {
  .container {
    max-width: 1440px;
  }
}
@media (max-width: 390px) {
  .header-line-1 {
    font-size: 55px !important;
  }
  .header-line-2 {
    font-size: 45px !important;
  }
  .header-line-3 {
    font-size: 35px !important;
  }
  .video-style {
    display: none;
  }
  .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.col-33 {
  width: 100%;
  margin-bottom: 40px;
}

.vehicle-table {
  display: table;
  height: 100%;
  width: 100%;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .header-line-1 {
    font-size: 38px !important;
  }
  .header-line-2 {
    font-size: 50px !important;
  }
  .header-line-3 {
    font-size: 43px !important;
  }
  h2.why-us {
    font-size: 24px;
  }
}
@media (min-width: 992px) {
  .col-33 {
    width: 33.33%;
    padding: 20px;
    box-sizing: border-box;
  }
}
@media (min-width: 1200px) {
  .vehicle-table {
    width: 80%;
  }
}
.retail-ready-svg {
  background-image: url(/assets/sites/tradesales/images/retailready.svg);
  width: 100px;
  height: 100px;
  background-position: center center;
  background-repeat: no-repeat;
}

.great-value-svg {
  background-image: url(/assets/sites/tradesales/images/greatvalue.svg);
  width: 100px;
  height: 100px;
  background-position: center center;
  background-repeat: no-repeat;
}

.easy-delivery-svg {
  background-image: url(/assets/sites/tradesales/images/easydelivery.svg);
  width: 100px;
  height: 100px;
  background-position: center center;
  background-repeat: no-repeat;
}

@media (min-width: 768px) and (max-width: 992px) {
  .header-line-1 {
    font-size: 38px !important;
  }
  .header-line-2 {
    font-size: 50px !important;
  }
  .header-line-3 {
    font-size: 38px !important;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .header-line-1 {
    font-size: 40px !important;
  }
  .header-line-2 {
    font-size: 50px !important;
  }
  .header-line-3 {
    font-size: 34px !important;
  }
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/home/homepage/homepage.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EAEE,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAIA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;AADF;;AAIA;EACE,0BAAA;EACA,cAAA;AADF;;AAIA;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AADF;;AAIA;EAEE,kDAAA;AAFF;;AAMA;EAEE,kDAAA;AAJF;;AAQA;EACE,sBAAA;AALF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,4BAAA;EACA,iCAAA;AALF;;AAQA;EAEE,cAAA;EACA,qBAAA;AANF;AAQE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;AANJ;AASE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;AAPJ;AAUE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;AARJ;;AAYA;EACE,gBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;AATF;AAWE;EACE,iCAAA;AATJ;;AAaA;EACE,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,oEAAA;EACA,uDAAA;EACA,iCAAA;AAVF;AAYE;EACE,uEAAA;AAVJ;;AAcA;EAEE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oDAAA;EACA,mBAAA;EACA,kBAAA;AAZF;AAcE;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,mBAAA;AAbJ;AAgBE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAdJ;;AAkBA;EAEE,wBAAA;EACA,qBAAA;EACA,gBAAA;AAhBF;;AAmBA;EAEE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;AAjBF;;AAoBA;EAEE,yDAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,oDAAA;AAlBF;AAoBE;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AAlBJ;AAoBI;EAEE,8CAAA;EACA,iDAAA;EACA,gBAAA;AAnBN;;AAyBA;EACE,gBAAA;EACA,mCAAA;AAtBF;;AAyBA;EACE,gBAAA;AAtBF;;AAyBA;EACE;IACE,iBAAA;EAtBF;AACF;AAyBA;EAEE;IACE,0BAAA;EAxBF;EA0BA;IACE,0BAAA;EAxBF;EA0BA;IACE,0BAAA;EAxBF;EA0BA;IACE,aAAA;EAxBF;EA0BA;IACE,0BAAA;IACA,2BAAA;EAxBF;AACF;AA4BA;EACE,WAAA;EACA,mBAAA;AA1BF;;AA6BA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AA1BF;;AAiCA;EACE;IACE,0BAAA;EA9BF;EAgCA;IACE,0BAAA;EA9BF;EAgCA;IACE,0BAAA;EA9BF;EAgCA;IACE,eAAA;EA9BF;AACF;AAkCA;EACE;IACE,aAAA;IACA,aAAA;IACA,sBAAA;EAhCF;AACF;AAmCA;EACE;IACE,UAAA;EAjCF;AACF;AAoCA;EACE,sEAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,4BAAA;AAlCF;;AAqCA;EACE,qEAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,4BAAA;AAlCF;;AAqCA;EACE,uEAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,4BAAA;AAlCF;;AAsCA;EACE;IACE,0BAAA;EAnCF;EAqCA;IACE,0BAAA;EAnCF;EAqCA;IACE,0BAAA;EAnCF;AACF;AAsCA;EAEE;IACE,0BAAA;EArCF;EAuCA;IACE,0BAAA;EArCF;EAuCA;IACE,0BAAA;EArCF;AACF","sourcesContent":["#homepage {\n  background-color: #fff;\n}\n\nh2 {\n  font-family: var(--font2);\n}\n\nh2.why-us {\n\n  font-size: 36px;\n  text-align: center;\n  color: var(--textColour);\n  letter-spacing: -1px;\n  font-weight: 700;\n}\n\nh3 {\n  color: #034fa0 !important;\n  font-size: 1.3rem;\n  font-weight: 700;\n}\n\nh3.no-test {\n  color: var(--primaryButtonColour) !important;\n}\n\n\n.header-line-1, .header-line-3 {\n  color: #717173 !important;\n  font-size: 38px !important;\n  font-weight: 500 !important;\n}\n\n.header-line-2 {\n  font-size: 50px !important;\n  color: #191c1f;\n}\n\n.btn-sign-up, .btn-login {\n  line-height: 50px;\n  display: inline-block;\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: -1px;\n}\n\n.center-box {\n\n  min-height: max(480px, var(--homepageVideoHeight))\n\n}\n\n.box-shadow {\n\n  box-shadow: 0 12px 32px 5px rgb(1 13 130 / 12%);\n\n}\n\n.block-1 {\n  background-color: #fff;\n}\n\n.block-2 {\n  background-color: var(--colour3);\n}\n\n.block-3 {\n  background-color: var(--colour3);\n}\n\n.inner-block-1 {\n  height: 100%;\n  width: 100%;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center right;\n}\n\n.header-block {\n\n  display: block;\n  color: var(--colour5);\n\n  .header-line-1 {\n    font-size: 48px;\n    line-height: 45px;\n    letter-spacing: -1px;\n    font-weight: 700;\n    font-family: var(--font2);\n  }\n\n  .header-line-2 {\n    font-size: 62px;\n    line-height: 54px;\n    font-weight: 700;\n    letter-spacing: -1px;\n    font-family: var(--font2);\n  }\n\n  .header-line-3 {\n    font-size: 48px;\n    line-height: 45px;\n    font-weight: 600;\n    letter-spacing: -1px;\n    color: #fff;\n    font-family: var(--font2);\n  }\n}\n\n.btn-sign-up {\n  font-weight: 600;\n  border-radius: 25px !important;\n  height: 50px;\n  padding: 0 25px;\n  border: none !important;\n  color: #fff !important;\n\n  &:hover {\n    background-color: #333 !important;\n  }\n}\n\n.btn-login {\n  font-weight: 600;\n  height: 50px;\n  border-radius: 25px !important;\n  padding: 0 25px;\n  border: 1.5px solid var(--tertiaryButtonBackgroundColour) !important;\n  color: var(--tertiaryButtonBackgroundColour) !important;\n  background-color: #fff !important;\n\n  &:hover {\n    background-color: var(--tertiaryButtonHoverBackgroundColour) !important;\n  }\n}\n\n.more-info-block {\n\n  display: block;\n  height: 100%;\n  background-color: #fff;\n  padding: 20px 40px 0 40px;\n  border-radius: 8px;\n  box-shadow: 0px 12px 32px 5px rgb(1 13 130 / 12%);\n  margin-bottom: 1rem;\n  text-align: center;\n\n  .info-text {\n    color: #333;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n  }\n\n  div {\n    padding-bottom: 6px;\n  }\n\n  h3 {\n    font-size: 1.3rem;\n    font-weight: 600;\n    margin-top: 20px;\n  }\n}\n\n.upcoming-sales {\n\n  color: var(--linkColour);\n  display: inline-block;\n  font-weight: 600;\n}\n\n.sales-calendar-button {\n\n  display: inline-block;\n  color: #fff;\n  padding: 5px 7px;\n  border-radius: 5px;\n  background-color: rgba(42, 157, 143, 0.8);\n  color: #fff;\n}\n\n.sale-table-wrapper {\n\n  background-color: var(--homepageCalendarBackgroundColour);\n  color: #fff;\n  border-radius: 8px;\n  padding: 10px 20px 10px 20px;\n  box-shadow: 0px 12px 32px 5px rgb(1 13 130 / 12%);\n\n  .sale-table {\n    width: 100%;\n    color: #fff;\n    font-weight: 500;\n    border-collapse: collapse;\n    border-style: hidden;\n\n    td {\n\n      border-top: 1px solid rgba(255, 255, 255, 0.1);\n      border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n      font-weight: 600;\n\n    }\n  }\n}\n\n.sub-header h3 {\n  font-weight: 700;\n  color: var(--textColour) !important;\n}\n\n#home-box1-widget {\n  min-width: 300px;\n}\n\n@media only screen and (min-width: 1200px) {\n  .container {\n    max-width: 1440px;\n  }\n}\n\n@media (max-width: 390px) {\n\n  .header-line-1 {\n    font-size: 55px !important;\n  }\n  .header-line-2 {\n    font-size: 45px !important;\n  }\n  .header-line-3 {\n    font-size: 35px !important;\n  }\n  .video-style {\n    display: none;\n  }\n  .container {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n}\n\n.col-33 {\n  width: 100%;\n  margin-bottom: 40px;\n}\n\n.vehicle-table {\n  display: table;\n  height: 100%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n\n}\n\n@media (max-width: 768px) {\n  .header-line-1 {\n    font-size: 38px !important;\n  }\n  .header-line-2 {\n    font-size: 50px !important;\n  }\n  .header-line-3 {\n    font-size: 43px !important;\n  }\n  h2.why-us {\n    font-size: 24px;\n  }\n}\n\n\n@media (min-width: 992px) {\n  .col-33 {\n    width: 33.33%;\n    padding: 20px;\n    box-sizing: border-box;\n  }\n}\n\n@media (min-width: 1200px) {\n  .vehicle-table {\n    width: 80%;\n  }\n}\n\n.retail-ready-svg {\n  background-image: url(/assets/sites/tradesales/images/retailready.svg);\n  width: 100px;\n  height: 100px;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n.great-value-svg {\n  background-image: url(/assets/sites/tradesales/images/greatvalue.svg);\n  width: 100px;\n  height: 100px;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n.easy-delivery-svg {\n  background-image: url(/assets/sites/tradesales/images/easydelivery.svg);\n  width: 100px;\n  height: 100px;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n\n@media (min-width: 768px) and (max-width: 992px) {\n  .header-line-1 {\n    font-size: 38px !important;\n  }\n  .header-line-2 {\n    font-size: 50px !important;\n  }\n  .header-line-3 {\n    font-size: 38px !important;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1200px) {\n\n  .header-line-1 {\n    font-size: 40px !important;\n  }\n  .header-line-2 {\n    font-size: 50px !important;\n  }\n  .header-line-3 {\n    font-size: 34px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
